<div class="mt-5 assets__page"> <!-- report__page__with__extra__scroll -->
    <form #assetsLiabilitiesForm="ngForm" novalidate="novalidate" autocomplete="off">

        <ng-container *ngIf="currentReport?.LATEST?.BALANCE_SHEET">

            <!-- #region "purchase-price" -->
            <div class="row mt-1">
                <div class="col-md-12">
                    <div class="color-secondary-gray font-size-16 font-weight-normal mb-3">
                        <!-- You will need to reference the Interim Balance Sheet or the Purchase Agreement or both.
                        <br>
                        Do not include intangible assets such as goodwill, licenses, non-compete, etc. -->
                        The Final Value will only include the Company's Fixed Assets and Goodwill (otherwise known as Asset Value).  Please identify if any additional Assets and Liabilities should be considered in the Final Value. You might need to reference the Company's most recent Balance Sheet as of the valuation date.<br />
                        <br />
                        If the proposed transaction is an Asset Sale, it is likely that only Fixed Assets (FF&E) will be the only assets included in the transaction unless otherwise stated in a Purchase Agreement or Letter of Intent. If the proposed transaction is a Stock Sale, it is likely that all assets and liabilities are included in the transaction unless otherwise stated in a Purchase Agreement or Letter of Intent.
                    </div>
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "assets" -->
            <div class="row my-5">
                <div class="col-md-12">
                    <div class="label">Check and enter all of the Assets that should be included in the Final Value of the Company</div>
                </div>

                <div class="col-md-12">

                    <div class="row my-3">
                        <div class="col-md-6">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #cashCheckBox [id]="cashCheckBox"
                                    (change)="cashCheckBox.value; currentReport.LATEST.BALANCE_SHEET.ASSET_CASH = null; callUpdateAPI('ASSET_CASH');"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="cashCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.ASSET_CASH || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">
                                        Cash<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            cash balance</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-6" *ngIf="cashCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_CASH"
                                [classes]="'input input__large input__blue'"
                                #ASSET_CASH="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="ASSET_CASH"
                                (blur)="callUpdateAPI('ASSET_CASH')"
                                id="ASSET_CASH"></number-input>

                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-6">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #arCheckBox [id]="arCheckBox"
                                    (change)="arCheckBox.value; currentReport.LATEST.BALANCE_SHEET.ASSET_AR = null; callUpdateAPI('ASSET_AR');"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="arCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.ASSET_AR || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">Trade A/R<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            trade accounts
                                            receivable</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-6" *ngIf="arCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_AR"
                                [classes]="'input input__large input__blue'"
                                #ASSET_AR="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="ASSET_AR"
                                (blur)="callUpdateAPI('ASSET_AR')"
                                id="ASSET_AR"></number-input>

                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-6">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #inventoryCheckBox
                                    [id]="inventoryCheckBox"
                                    (change)="inventoryCheckBox.value; currentReport.LATEST.BALANCE_SHEET.ASSET_INVENTORY = null; callUpdateAPI('ASSET_INVENTORY')"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="inventoryCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.ASSET_INVENTORY || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">Inventory<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            inventory value</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-6" *ngIf="inventoryCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_INVENTORY"
                                [classes]="'input input__large input__blue'"
                                #ASSET_INVENTORY="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="ASSET_INVENTORY"
                                (blur)="callUpdateAPI('ASSET_INVENTORY')"
                                id="ASSET_INVENTORY"></number-input>

                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-6">
                            <label class="checkbox large m-0">
                                <input class="checkbox__input" type='checkbox' #fixedCheckBox [id]="fixedCheckBox"
                                    (change)="fixedCheckBox.value; currentReport.LATEST.BALANCE_SHEET.ASSET_FIXED_COST = null; callUpdateAPI('ASSET_FIXED_COST');"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="fixedCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.ASSET_FIXED_COST || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">Fixed Assets<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company is
                                            including fixed assets in
                                            the sale, net of depreciation</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-6" *ngIf="fixedCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_FIXED_COST"
                                [classes]="'input input__large input__blue'"
                                #ASSET_FIXED_COST="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="ASSET_FIXED_COST"
                                (blur)="callUpdateAPI('ASSET_FIXED_COST')"
                                id="ASSET_FIXED_COST"></number-input>

                        </div>

                        <ng-container *ngIf="fixedCheckBox.checked">
                            <div class="col-md-6 text-right color-secondary-gray font-size-14 font-weight-normal pr-5 mt-1">
                                {{currentReport.LATEST.BALANCE_SHEET.ASSET_FIXED_APPRAISED ? '(separately appraised)' : '(net book value)'}}
                            </div>
                            <div class="col-md-6 mt-1">
                                <label class="checkbox m-0">
                                    <input class="checkbox__input" type='checkbox' #ASSET_FIXED_APPRAISED [id]="ASSET_FIXED_APPRAISED"
                                        [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_FIXED_APPRAISED"
                                        [disabled]="currentReport?.isLocked"
                                        (change)="callUpdateAPI('ASSET_FIXED_APPRAISED');" />

                                    <div class="checkbox__data p-0">
                                        <div class="checkbox__indicator"></div>

                                        <p class="checkbox__text">
                                            <span class="color-secondary-gray font-size-14 font-weight-normal">Check if fixed assets have been appraised</span>
                                        </p>
                                    </div>
                                </label>

                            </div>
                        </ng-container>
                    </div>

                    <div class="row my-3" *ngIf="reportService.hasOwnedLocationsOnBalance()">
                        <div class="col-md-6">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #realEstateCheckBox
                                    [id]="realEstateCheckBox"
                                    (change)="realEstateCheckBox.value; currentReport.LATEST.BALANCE_SHEET.ASSET_REAL_ESTATE = null; callUpdateAPI('ASSET_REAL_ESTATE');"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="realEstateCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.ASSET_REAL_ESTATE || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">Real Estate (net)<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">The net book
                                            value or appraised value
                                            of any real estate owned by
                                            the Company. The net book value is the value on the Company's balance sheet
                                            less any
                                            accumulated depreciation</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-6" *ngIf="realEstateCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_REAL_ESTATE"
                                [classes]="'input input__large input__blue'"
                                #ASSET_REAL_ESTATE="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="ASSET_REAL_ESTATE"
                                (blur)="callUpdateAPI('ASSET_REAL_ESTATE')"
                                id="ASSET_REAL_ESTATE"></number-input>

                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-6">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #otherAssetCheckBox [id]="otherAssetCheckBox"
                                    (change)="otherAssetCheckBox.value; currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER = null; currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER_LABEL = null; callResetOtherAPI(['ASSET_OTHER_LABEL', 'ASSET_OTHER']);"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="otherAssetCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER || currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER_LABEL || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">Other Assets<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">The other
                                            assets being included in
                                            the sale</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-6" *ngIf="otherAssetCheckBox.checked">
                            <input type="text" appAlpaNumericWithSpace class="input input__large input__blue mb-1"
                            id="assets-lib-asset-balance-sheet"
                                maxlength="50" [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER_LABEL"
                                name="ASSET_OTHER_LABEL" [disabled]="currentReport?.isLocked"
                                (blur)="callUpdateAPI('ASSET_OTHER_LABEL')"
                                (keyup.enter)="callUpdateAPI('ASSET_OTHER_LABEL')"
                                placeholder="Description e.g. ‘Note Receivable’">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.ASSET_OTHER"
                                [classes]="'input input__large input__blue'"
                                #ASSET_OTHER="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="ASSET_OTHER"
                                (blur)="callUpdateAPI('ASSET_OTHER')"
                                id="ASSET_OTHER"></number-input>

                        </div>
                    </div>

                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "liabilities" -->
            <div class="row my-5">
                <div class="col-md-12">
                    <div class="label">Check and enter all of the Liabilities that should be included in the Final Value of the Company</div>
                </div>

                <!-- When Transaction Type is Not Debt Refinance -->
                <div class="col-md-12" *ngIf="!isDebtRefinance">

                    <div class="row my-3">
                        <div class="col-md-6">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #apCheckBox [id]="apCheckBox"
                                    (change)="apCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP = null; callUpdateAPI('LIABILITY_AP');"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="apCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">
                                        Trade A/P<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            trade accounts
                                            payable</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-6" *ngIf="apCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_AP="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="LIABILITY_AP"
                                (blur)="callUpdateAPI('LIABILITY_AP')"
                                id="LIABILITY_AP"></number-input>

                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-6">

                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #shortTermCheckBox
                                    [id]="shortTermCheckBox"
                                    (change)="shortTermCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES = null; callUpdateAPI('LIABILITY_SHORT_TERM_NOTES');"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="shortTermCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">
                                        Short Term Notes<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            short term notes</span>
                                    </p>
                                </div>
                            </label>

                        </div>
                        <div class="col-md-6" *ngIf="shortTermCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_SHORT_TERM_NOTES="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="LIABILITY_SHORT_TERM_NOTES"
                                (blur)="callUpdateAPI('LIABILITY_SHORT_TERM_NOTES')"
                                id="LIABILITY_SHORT_TERM_NOTES"></number-input>

                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-6">

                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #longEstateCheckBox
                                    [id]="longEstateCheckBox"
                                    (change)="longEstateCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM = null; callUpdateAPI('LIABILITY_LONG_TERM');"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="longEstateCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">
                                        Long Term Liabilities<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            long term
                                            liabilities</span>
                                    </p>
                                </div>
                            </label>

                        </div>
                        <div class="col-md-6" *ngIf="longEstateCheckBox.checked">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_LONG_TERM="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="LIABILITY_LONG_TERM"
                                (blur)="callUpdateAPI('LIABILITY_LONG_TERM')"
                                id="LIABILITY_LONG_TERM"></number-input>

                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-6">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #otherLiabilityCheckBox [id]="otherLiabilityCheckBox"
                                    (change)="otherLiabilityCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER = null; currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL = null; callResetOtherAPI(['LIABILITY_OTHER_LABEL', 'LIABILITY_OTHER']);"
                                    [disabled]="isCheckBoxDisabled || currentReport?.isLocked"
                                    [checked]="otherLiabilityCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER || currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>
                                    <p class="checkbox__text">
                                        Other Liabilities<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Other
                                            liabilities being included in
                                            the sale</span>
                                    </p>
                                </div>
                            </label>
                        </div>
                        <div class="col-md-6" *ngIf="otherLiabilityCheckBox.checked">
                            <input type="text" appAlpaNumericWithSpace class="input input__blue input__large mb-1"
                                maxlength="50" [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL"
                                name="LIABILITY_OTHER_LABEL" [disabled]="currentReport?.isLocked"
                                (blur)="callUpdateAPI('LIABILITY_OTHER_LABEL')"
                                placeholder="Description e.g. ‘Note Payable’"
                                id="assets-lib-other-label"
                                (keyup.enter)="callUpdateAPI('LIABILITY_OTHER_LABEL')">

                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_OTHER="ngModel"
                                [required]="false" [disabled]="currentReport?.isLocked"
                                name="LIABILITY_OTHER"
                                (blur)="callUpdateAPI('LIABILITY_OTHER')"
                                id="LIABILITY_OTHER"></number-input>

                        </div>
                    </div>

                </div>

                <!-- When Transaction Type is Debt Refinance -->
                <div class="col-md-12" *ngIf="isDebtRefinance">

                    <div class="row my-3 font-weight-bold color-secondary-gray font-size-16">
                        <div class="col-md-12">
                            <div class="row justify-content-end">
                                <div class="col-md-4">Liabilities being refinanced</div>
                                <div class="col-md-4">Total liabilities on balance sheet</div>
                            </div>
                            <div class="row justify-content-end mt-2 px-3">
                                <div class="col-md-4 blue-border-bottom-2"></div>
                                <div class="col-md-4 blue-border-bottom-2"></div>
                            </div>
                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-4">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #apCheckBox [id]="apCheckBox"
                                    (change)="apCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP = null; callUpdateAPI('LIABILITY_AP');"
                                    [disabled]="isCheckBoxDisabled || currentReport.isLocked"
                                    [checked]="apCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">
                                        Trade A/P<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            trade accounts
                                            payable</span>
                                    </p>
                                </div>
                            </label>
                        </div>

                        <div class="col-md-4" *ngIf="apCheckBox.checked">
                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP_REF"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_AP_REF="ngModel"
                                [required]="false" [disabled]="currentReport.isLocked"
                                name="LIABILITY_AP_REF"
                                (blur)="callUpdateAPI('LIABILITY_AP_REF')"
                                id="LIABILITY_AP_REF"></number-input>
                        </div>
                        <div class="col-md-4" *ngIf="apCheckBox.checked">
                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_AP"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_AP="ngModel" [required]="false"
                                name="LIABILITY_AP" [disabled]="currentReport.isLocked"
                                (blur)="callUpdateAPI('LIABILITY_AP')"
                                id="LIABILITY_AP"></number-input>
                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-4">

                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #shortTermCheckBox
                                    [id]="shortTermCheckBox"
                                    (change)="shortTermCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES = null; callUpdateAPI('LIABILITY_SHORT_TERM_NOTES');"
                                    [disabled]="isCheckBoxDisabled || currentReport.isLocked"
                                    [checked]="shortTermCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">
                                        Short Term Notes<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            short term notes</span>
                                    </p>
                                </div>
                            </label>

                        </div>
                        <div class="col-md-4" *ngIf="shortTermCheckBox.checked">
                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES_REF"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_SHORT_TERM_NOTES_REF="ngModel"
                                [required]="false" [disabled]="currentReport.isLocked"
                                name="LIABILITY_SHORT_TERM_NOTES_REF"
                                (blur)="callUpdateAPI('LIABILITY_SHORT_TERM_NOTES_REF')"
                                id="LIABILITY_SHORT_TERM_NOTES_REF"></number-input>
                        </div>
                        <div class="col-md-4" *ngIf="shortTermCheckBox.checked">
                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_SHORT_TERM_NOTES"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_SHORT_TERM_NOTES="ngModel"
                                [required]="false" [disabled]="currentReport.isLocked"
                                name="LIABILITY_SHORT_TERM_NOTES"
                                (blur)="callUpdateAPI('LIABILITY_SHORT_TERM_NOTES')"
                                id="LIABILITY_SHORT_TERM_NOTES"></number-input>
                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-4">

                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #longEstateCheckBox
                                    [id]="longEstateCheckBox"
                                    (change)="longEstateCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM = null; callUpdateAPI('LIABILITY_LONG_TERM');"
                                    [disabled]="isCheckBoxDisabled || currentReport.isLocked"
                                    [checked]="longEstateCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>

                                    <p class="checkbox__text">
                                        Long Term Liabilities<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Company’s
                                            long term
                                            liabilities</span>
                                    </p>
                                </div>
                            </label>

                        </div>

                        <div class="col-md-4" *ngIf="longEstateCheckBox.checked">
                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM_REF"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_LONG_TERM_REF="ngModel"
                                [required]="false" [disabled]="currentReport.isLocked"
                                name="LIABILITY_LONG_TERM_REF"
                                (blur)="callUpdateAPI('LIABILITY_LONG_TERM_REF')"
                                id="LIABILITY_LONG_TERM_REF"></number-input>
                        </div>
                        <div class="col-md-4" *ngIf="longEstateCheckBox.checked">
                            <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_LONG_TERM"
                                [classes]="'input input__large input__blue'"
                                #LIABILITY_LONG_TERM="ngModel"
                                [required]="false" [disabled]="currentReport.isLocked"
                                name="LIABILITY_LONG_TERM"
                                (blur)="callUpdateAPI('LIABILITY_LONG_TERM')"
                                id="LIABILITY_LONG_TERM"></number-input>
                        </div>
                    </div>

                    <div class="row my-3">
                        <div class="col-md-4">
                            <label class="checkbox large">
                                <input class="checkbox__input" type='checkbox' #otherLiabilityCheckBox [id]="otherLiabilityCheckBox"
                                    (change)="otherLiabilityCheckBox.value; currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER = null; currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL = null; callResetOtherAPI(['LIABILITY_OTHER_LABEL', 'LIABILITY_OTHER']);"
                                    [disabled]="isCheckBoxDisabled || currentReport.isLocked"
                                    [checked]="otherLiabilityCheckBox.checked || currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER || currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL || isCheckBoxDisabled" />
                                <div class="checkbox__data">
                                    <div class="checkbox__indicator" *ngIf="!isCheckBoxDisabled"></div>
                                    <p class="checkbox__text">
                                        Other Liabilities<br />
                                        <span class="color-secondary-gray font-size-14 font-weight-normal">Other
                                            liabilities being included in
                                            the sale</span>
                                    </p>
                                </div>
                            </label>
                        </div>
                        <div class="col-md-8" *ngIf="otherLiabilityCheckBox.checked">
                            <input type="text" appAlpaNumericWithSpace class="input input__blue input__large mb-1"
                                maxlength="50" [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_LABEL"
                                name="LIABILITY_OTHER_LABEL" [disabled]="currentReport.isLocked"
                                (blur)="callUpdateAPI('LIABILITY_OTHER_LABEL')"
                                placeholder="Description e.g. ‘Note Payable’"
                                id="assets-lib-other-label"
                                (keyup.enter)="callUpdateAPI('LIABILITY_OTHER_LABEL')">
                        </div>
                        <div class="col-md-12" *ngIf="otherLiabilityCheckBox.checked">
                            <div class="row justify-content-end">
                                <div class="col-md-4">
                                    <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER_REF"
                                    [classes]="'input input__large input__blue'"
                                    #LIABILITY_OTHER_REF="ngModel"
                                    [required]="false" [disabled]="currentReport.isLocked"
                                    name="LIABILITY_OTHER_REF"
                                    (blur)="callUpdateAPI('LIABILITY_OTHER_REF')"
                                    id="LIABILITY_OTHER_REF"></number-input>
                                </div>
                                <div class="col-md-4">
                                    <number-input [(ngModel)]="currentReport.LATEST.BALANCE_SHEET.LIABILITY_OTHER"
                                    [classes]="'input input__large input__blue'"
                                    #LIABILITY_OTHER="ngModel"
                                    [required]="false" [disabled]="currentReport.isLocked"
                                    name="LIABILITY_OTHER"
                                    (blur)="callUpdateAPI('LIABILITY_OTHER')"
                                    id="LIABILITY_OTHER"></number-input>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </div>
            <!-- #endregion -->

        </ng-container>

    </form>
</div>
<report-footer (buttonClicked)="footerButtonClick($event)" [pageId]="reportPageConst.ASSETS_LIABILITIES"></report-footer>
